import React from 'react';
// import LogoWhite from '../../assets/icons/logo-white.png';
// import LogoWhite from '../../assets/images/new-logo.webp';

const PerformanceCheckReportHeader = ({ mini = false }) => {
  return (
    <header className={`paper_header ${mini ? 'mini' : ''}`}>
      <div className="">
        {/* <Image className="" src={LogoWhite} alt="logo" width="30" /> */}
        <p className="">HANDOK Inspection</p>
      </div>
      <p className="text-2xl">한독성능장</p>
    </header>
  );
};

export default PerformanceCheckReportHeader;
